import { useState, useEffect } from "react";
import { PageHeader } from "@/components/Common";
import api from "@/lib/api";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { LoungeContentTab } from "@/components/lounge-admin/LoungeContentTab";
import { LoungeGuidelinesTab } from "@/components/lounge-admin/LoungeGuidelinesTab";
import { LoungeRequestsAdminTab } from "@/components/lounge-admin/LoungeRequestsAdminTab";
import { MediaLibraryTab } from "@/components/lounge-admin/MediaLibraryTab";
import { PressReleasesTab } from "@/components/lounge-admin/PressReleasesTab";
import { PressSubscribersTab } from "@/components/lounge-admin/PressSubscribersTab";
import { PressStatsTab } from "@/components/lounge-admin/PressStatsTab";
import { FileText, Image as ImageIcon, Newspaper, ScrollText, Inbox, ExternalLink, Mail, BarChart3 } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function PressLoungeAdmin() {
  const [unread, setUnread] = useState(0);
  useEffect(() => {
    api.get("/lounge/pending-counts").then(({ data }) => setUnread(data.press || 0)).catch(() => {});
  }, []);
  return (
    <div data-testid="press-lounge-admin">
      <PageHeader
        eyebrow="Lounge"
        title="Gestione Press Lounge"
        subtitle="Contenuti, comunicati, libreria media, regole e richieste della pagina pubblica Press & Media."
        actions={
          <a href="/press-lounge" target="_blank" rel="noopener noreferrer">
            <Button variant="outline" size="sm" data-testid="press-view-public"><ExternalLink className="mr-1.5 h-4 w-4" /> Vedi pagina pubblica</Button>
          </a>
        }
      />
      <Tabs defaultValue="content">
        <TabsList className="flex-wrap">
          <TabsTrigger value="content" data-testid="press-tab-content"><FileText className="mr-1.5 h-4 w-4" /> Contenuti</TabsTrigger>
          <TabsTrigger value="releases" data-testid="press-tab-releases"><Newspaper className="mr-1.5 h-4 w-4" /> Comunicati</TabsTrigger>
          <TabsTrigger value="media" data-testid="press-tab-media"><ImageIcon className="mr-1.5 h-4 w-4" /> Libreria Media</TabsTrigger>
          <TabsTrigger value="rules" data-testid="press-tab-rules"><ScrollText className="mr-1.5 h-4 w-4" /> Regole materiale</TabsTrigger>
          <TabsTrigger value="requests" data-testid="press-tab-requests">
            <Inbox className="mr-1.5 h-4 w-4" /> Richieste
            {unread > 0 && <span className="ml-1.5 inline-flex h-4 min-w-[16px] items-center justify-center rounded-full bg-brema-red px-1 text-[10px] font-bold leading-none text-white" data-testid="press-requests-badge">{unread}</span>}
          </TabsTrigger>
          <TabsTrigger value="subscribers" data-testid="press-tab-subscribers"><Mail className="mr-1.5 h-4 w-4" /> Iscritti stampa</TabsTrigger>
          <TabsTrigger value="stats" data-testid="press-tab-stats"><BarChart3 className="mr-1.5 h-4 w-4" /> Statistiche & Report</TabsTrigger>
        </TabsList>
        <TabsContent value="content" className="mt-6"><LoungeContentTab page="press" /></TabsContent>
        <TabsContent value="releases" className="mt-6"><PressReleasesTab /></TabsContent>
        <TabsContent value="media" className="mt-6"><MediaLibraryTab page="press" /></TabsContent>
        <TabsContent value="rules" className="mt-6">
          <LoungeGuidelinesTab page="press" title="Regole per la richiesta di materiale" description="Punti mostrati a riviste e testate accanto al modulo di richiesta materiale." />
        </TabsContent>
        <TabsContent value="requests" className="mt-6"><LoungeRequestsAdminTab page="press" onCount={setUnread} /></TabsContent>
        <TabsContent value="subscribers" className="mt-6"><PressSubscribersTab /></TabsContent>
        <TabsContent value="stats" className="mt-6"><PressStatsTab /></TabsContent>
      </Tabs>
    </div>
  );
}
